// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FeedbackSummary[data-v-0404569c]{background:#fff;padding:1.785714rem 1rem}.FeedbackSummary .header[data-v-0404569c]{text-align:center;margin-bottom:1.857143rem}.FeedbackSummary .header h1[data-v-0404569c]{font-size:2.142857rem;margin:0}.FeedbackSummary .header .summaryDescription[data-v-0404569c]{font-size:16px;font-weight:700;color:#707070}", ""]);
// Exports
module.exports = exports;
